(function () {
  if (window.DragoCartAjaxInitialized) return;
  window.DragoCartAjaxInitialized = true;

  function setCartCount(count) {
    document.querySelectorAll('.cart-badge').forEach(function (badge) {
      badge.textContent = count;
    });
  }

  function setButtonState(button, label, disabled) {
    if (!button) return;
    button.textContent = label;
    button.disabled = disabled;
  }

  function setMobileMenu(open) {
    var menu = document.querySelector('[data-mobile-menu]');
    var toggle = document.querySelector('[data-mobile-menu-toggle]');
    var backdrop = document.querySelector('.mobile-menu-backdrop');
    if (!menu || !toggle || !backdrop) return;

    var wasOpen = menu.classList.contains('is-open');
    menu.classList.toggle('is-open', open);
    backdrop.classList.toggle('is-open', open);
    document.body.classList.toggle('mobile-menu-open', open);
    toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    toggle.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');

    if (open) {
      var firstLink = menu.querySelector('a, button');
      if (firstLink) firstLink.focus();
    } else if (wasOpen) {
      toggle.focus();
    }
  }

  var toastTimer;

  function showToast(message, type) {
    if (!message) return;

    var toast = document.querySelector('[data-cart-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.setAttribute('data-cart-toast', '');
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      toast.className = 'cart-toast';
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.className = 'cart-toast is-visible' + (type ? ' is-' + type : '');

    window.clearTimeout(toastTimer);
    toastTimer = window.setTimeout(function () {
      toast.classList.remove('is-visible');
    }, type === 'error' ? 4800 : 1600);
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
      style: 'currency',
      currency: 'USD'
    }).format(cents / 100);
  }

  function setCartStatus(message) {
    var status = document.querySelector('[data-cart-status]');
    if (!status) return;
    status.textContent = message || '';
  }

  function updateCartLine(line, item) {
    if (!line) return;
    if (!item) {
      line.remove();
      return;
    }

    var value = line.querySelector('[data-cart-quantity]');
    var input = line.querySelector('[data-cart-quantity-input]');
    var price = line.querySelector('[data-line-price]');

    if (input) input.value = item.quantity;
    if (value) value.textContent = item.quantity;
    if (price) price.textContent = formatMoney(item.final_line_price);
  }

  function updateCartTotals(cart) {
    var total = document.querySelector('[data-cart-total]');
    if (total) total.textContent = formatMoney(cart.total_price);
    setCartCount(cart.item_count);

    if (cart.item_count === 0) {
      window.location.reload();
    }
  }

  function syncCartFromServer(key) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        var line = document.querySelector('[data-line-key="' + key + '"]');
        var item = cart.items.find(function (cartItem) {
          return cartItem.key === key;
        });

        updateCartLine(line, item);
        updateCartTotals(cart);
        return cart;
      });
  }

  function changeCartLine(line, quantity) {
    if (!line || line.dataset.updating === 'true') return;

    var key = line.getAttribute('data-line-key');
    line.dataset.updating = 'true';
    line.style.opacity = '.6';

    fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: quantity
      })
      })
      .then(function (response) {
        return response.json().then(function (payload) {
          if (!response.ok) {
            var error = new Error(payload.description || payload.message || 'Unable to update cart');
            error.payload = payload;
            throw error;
          }
          return payload;
        });
      })
      .then(function (cart) {
        var item = cart.items.find(function (cartItem) {
          return cartItem.key === key;
        });
        updateCartLine(line, item);
        updateCartTotals(cart);
        showToast('Cart updated', 'success');
      })
      .catch(function (error) {
        syncCartFromServer(key).finally(function () {
          showToast(error.message || 'Unable to update cart', 'error');
        });
      })
      .finally(function () {
        line.dataset.updating = 'false';
        line.style.opacity = '';
      });
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (form.matches('.cart-form')) {
      var agreement = form.querySelector('[data-cart-policy-agreement]');
      if (agreement && !agreement.checked) {
        event.preventDefault();
        agreement.focus();
        showToast('Please agree to the store policies before checkout.', 'error');
      }
      return;
    }

    if (!form.matches('.prod-form')) return;

    event.preventDefault();

    var button = form.querySelector('button[type="submit"]');
    var originalLabel = button ? button.textContent : 'Add to Cart';

    setButtonState(button, 'Adding...', true);

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: {
        Accept: 'application/json'
      }
    })
      .then(function (response) {
        if (!response.ok) {
          return response.json().then(function (payload) {
            throw new Error(payload.description || 'Unable to add item');
          });
        }
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (response) {
        return response.json();
      })
      .then(function (cart) {
        setCartCount(cart.item_count);
        setButtonState(button, 'Added', true);
        window.setTimeout(function () {
          setButtonState(button, originalLabel, false);
        }, 1200);
      })
      .catch(function () {
        setButtonState(button, 'Try again', false);
        window.setTimeout(function () {
          setButtonState(button, originalLabel, false);
        }, 1800);
      });
  });

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (input.matches('[data-cart-policy-agreement]')) {
      var checkoutButton = document.querySelector('[data-cart-checkout]');
      if (checkoutButton) checkoutButton.disabled = !input.checked;
      return;
    }

    if (input.matches('[data-product-variant-select]')) {
      var option = input.options[input.selectedIndex];
      var form = input.closest('.product-form');
      var page = input.closest('.product-page');
      var image = page ? page.querySelector('[data-product-image]') : null;
      var price = page ? page.querySelector('[data-product-price]') : null;
      var submit = form ? form.querySelector('[data-product-submit]') : null;
      var available = option.getAttribute('data-available') === 'true';
      var imageUrl = option.getAttribute('data-image');

      if (price) price.textContent = option.getAttribute('data-price') || '';
      if (image && imageUrl) {
        image.src = imageUrl;
        image.alt = option.getAttribute('data-image-alt') || option.textContent.trim();
      }
      if (submit) {
        submit.disabled = !available;
        submit.textContent = available ? 'Add to Cart' : 'Sold out';
      }
      return;
    }

    if (!input.matches('[data-cart-quantity-input]')) return;

    var line = input.closest('[data-cart-line]');
    var quantity = Math.max(0, parseInt(input.value, 10) || 0);
    changeCartLine(line, quantity);
  });

  document.addEventListener('click', function (event) {
    var mobileToggle = event.target.closest('[data-mobile-menu-toggle]');
    if (mobileToggle) {
      var isOpen = mobileToggle.getAttribute('aria-expanded') === 'true';
      setMobileMenu(!isOpen);
      return;
    }

    if (event.target.closest('[data-mobile-menu-close]')) {
      setMobileMenu(false);
      return;
    }

    var mobileMenuLink = event.target.closest('[data-mobile-menu] a');
    if (mobileMenuLink) {
      setMobileMenu(false);
      return;
    }

    var stepButton = event.target.closest('[data-cart-decrement], [data-cart-increment]');
    if (stepButton) {
      var stepLine = stepButton.closest('[data-cart-line]');
      var quantityNode = stepLine ? stepLine.querySelector('[data-cart-quantity]') : null;
      var currentQuantity = quantityNode ? parseInt(quantityNode.textContent, 10) || 0 : 0;
      var nextQuantity = stepButton.matches('[data-cart-increment]') ? currentQuantity + 1 : Math.max(0, currentQuantity - 1);
      changeCartLine(stepLine, nextQuantity);
      return;
    }

    var button = event.target.closest('[data-cart-remove]');
    if (!button) return;

    var line = button.closest('[data-cart-line]');
    changeCartLine(line, 0);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      setMobileMenu(false);
    }
  });
})();
